import React from 'react';
import { NotificationItem } from './NotificationItem';

interface NotificationSectionProps {
    title?: string;
    items: Array<{
        label: string;
        description: string;
        checked: boolean;
        disabled?: boolean;
        onChange: (checked: boolean) => void;
    }>;
}

export const NotificationSection: React.FC<NotificationSectionProps> = ({ title, items }) => {
    return (
        <div className="notification-section">
            {title && <h3 className="section-title">{title}</h3>}
            {items.map((item, index) => (
                <NotificationItem
                    key={index}
                    label={item.label}
                    description={item.description}
                    checked={item.checked}
                    disabled={item.disabled}
                    onChange={item.onChange}
                />
            ))}
        </div>
    );
};
